module.exports = __webpack_public_path__ + "img/W-23.794b56c2.jpg";